<template>
  <div
    class="d-flex-row space-between"
    v-for="packSelectedOption in selectedItems"
    :key="packSelectedOption"
  >
    <div class="d-flex-row justify-start flex-8">
      <p
        class="t-grey font-family-2 regular-l"
        style="text-transform: uppercase"
      >
        {{ packSelectedOption.title }}
      </p>
    </div>
    <p class="t-white font-family-2 bold-l">
      {{ renderPrice(packSelectedOption) }}
    </p>
  </div>
</template>

<script setup>
const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();
const userStore = useUserStore();

const selectedItems = computed(() => {
  const items = checkoutStore.getDetails?.items || [];
  if (!items) return [];

  const packPrices = gameStore.getGamePack?.prices || [];
  const ii = packPrices?.filter((pp) => items.includes(pp.id)) || [];
  return ii;
});

const renderPrice = (packOption) => {
  if (packOption.type === "free") {
    return packOption.type;
  } else if (packOption.type === "variable") {
    return `${packOption.price}%`;
  } else if (packOption.type === "fixed") {
    return `${parseFloat(calculateCurrency(packOption.price)).toFixed(
      2
    )}${handleCurrency(getUserCurrency)}`;
  } else {
    return `${userStore.getUserCurrencyCode}${parseFloat(
      packOption.price
    ).toFixed(2)}`;
  }
};
</script>
